import Paragraph from '@vimcar/shared-components/components/Paragraph'
import cx from 'classnames'
import React from 'react'
// import colors from '@vimcar/shared-utils/styles/colors'

import styles from './styles.css'

type Props = {
  text: string
  subtext: string
  disabled?: boolean
  onClick?: () => void
  className?: string
}

const MultiLineButton = ({
  text,
  subtext,
  disabled,
  onClick,
  className,
}: Props) => (
  <button
    className={cx(styles.button, className)}
    disabled={disabled}
    onClick={onClick}
  >
    <Paragraph
      className={cx(styles.text, { [styles.textDisabled]: disabled })}
      variant='subtitle2'
    >
      {text}
    </Paragraph>
    <Paragraph
      className={cx(styles.text, { [styles.textDisabled]: disabled })}
      variant='subtitle3'
    >
      {subtext}
    </Paragraph>
  </button>
)

export default MultiLineButton
